import React, { Component } from 'react'
import {
	Alert,
	Button,
	Container,
	Col,
	DropdownItem,
	DropdownMenu,
	DropdownToggle,
	Form,
	FormGroup,
	FormText,
	Input,
	Label,
	Modal,
	ModalHeader,
	ModalBody,
	ModalFooter,
	UncontrolledAlert,
	UncontrolledDropdown
} from 'reactstrap';
import axios from 'axios';

class AdminBroadcastAlertForm extends Component {

	handleContentChange = (e) => {
		this.setState({content: e.target.value});
	};

	onColorDropdownClick = (color) => {
		this.setState({color: color});
	};

	toggleSaveModal = () => {
		this.setState({
			saveModal: !this.state.saveModal,
		});
	};

	get = () => {
		if (process.env.REACT_APP_FRONT_END === "true") {
			return;
		}
		axios.get('/api/broadcast-alert')
		.then((res) => {
			if (res) {
				this.setState({
					color: res.data.color,
					content: res.data.content
				});
			}
		})
		.catch((err) => {

		});
	};

	post = () => {
		axios.post('/api/broadcast-alert', {
			color: this.state.color,
			content: this.state.content
		})
		.then((res) => {
			this.setState({
				saveModal: true,
				modalSuccess: true
			});
		})
		.catch((err) => {
			this.setState({
				saveModal: true,
				modalSuccess: false
			});
		});
	};

	constructor(props) {
		super(props);

		this.state = {
			color: 'primary',
			content: '',
			saveModal: false,
			modalSuccess: false
		}
	}

	componentDidMount() {
		this.get();
	}

	render() {
		return (
			<div>
				<Form id="broadcast-alert-form">
					<FormGroup>
						<Label for="content">Alert Message</Label>
						<Input type="text" size="lg" value={this.state.content} onChange={(e) => this.handleContentChange(e)}  />
						<FormText color="muted">
							Leave blank to remove
						</FormText>
					</FormGroup>	
					<FormGroup>
						<UncontrolledDropdown>
							<DropdownToggle caret>
								Alert Color
							</DropdownToggle>
							<DropdownMenu>
								<DropdownItem onClick={() => this.onColorDropdownClick('primary')}>Primary</DropdownItem>
								<DropdownItem onClick={() => this.onColorDropdownClick('secondary')}>Secondary</DropdownItem>
								<DropdownItem onClick={() => this.onColorDropdownClick('success')}>Success</DropdownItem>
								<DropdownItem onClick={() => this.onColorDropdownClick('danger')}>Danger</DropdownItem>
								<DropdownItem onClick={() => this.onColorDropdownClick('warning')}>Warning</DropdownItem>
								<DropdownItem onClick={() => this.onColorDropdownClick('info')}>Info</DropdownItem>
								<DropdownItem onClick={() => this.onColorDropdownClick('light')}>Light</DropdownItem>
								<DropdownItem onClick={() => this.onColorDropdownClick('dark')}>Dark</DropdownItem>
							</DropdownMenu>
						</UncontrolledDropdown>
						<FormText color="muted">
							Selected: {this.state.color}
						</FormText>
					</FormGroup>
					<FormGroup>
						<Label for="preview">Preview</Label>
						<Alert name="preview" color={this.state.color}>
							{this.state.content}
						</Alert>
					</FormGroup>
					<Button color="primary" onClick={this.post}>Save Changes</Button>{' '}
				</Form>
				<Modal isOpen={this.state.saveModal} toggle={this.toggleSaveModal}>
					<ModalHeader toggle={this.toggleSaveModal}>Broadcast Alert</ModalHeader>
					<ModalBody>
						{this.state.modalSuccess ? (
							<div>Your changes have been saved.</div>
						) : (
							<div>ERROR: Could not save changes. Try again later.</div>
						)}
					</ModalBody>
					<ModalFooter>
						<Button color="primary" onClick={this.toggleSaveModal}>OK</Button>
					</ModalFooter>
				</Modal>
			</div>
		);
	}
};

export default AdminBroadcastAlertForm


// WEBPACK FOOTER //
// ./src/admin-components/AdminBroadcastAlertForm.js